
















import Vue from 'vue'
import { CheckboxGroupElInterface, List } from '@/config/interfaces'

export default Vue.extend({
  name: 'CheckboxGroupEl',
  methods: {
    toBoolean (item: List): List {
      if (typeof item.value === 'string') {
        item.value = (item.value.toLowerCase() === 'true')
      }
      return item
    },
    mapValues (items:Array<List>) : Array <List> {
      return items.map(value => this.toBoolean(value))
    }
  },
  props: {
    templateItemData: {
      type: Object as () => CheckboxGroupElInterface,
      required: true
    }
  }
})
